import { DockLocation as s } from "../DockLocation.js";
import { Orientation as n } from "../Orientation.js";
import { Rect as h } from "../Rect.js";
class u {
  /** @internal */
  _model;
  /** @internal */
  _attributes;
  /** @internal */
  _parent;
  /** @internal */
  _children;
  /** @internal */
  _fixed;
  /** @internal */
  _rect;
  /** @internal */
  _visible;
  /** @internal */
  _listeners;
  /** @internal */
  _dirty = !1;
  /** @internal */
  _tempSize = 0;
  /** @internal */
  constructor(t) {
    this._model = t, this._attributes = {}, this._children = [], this._fixed = !1, this._rect = h.empty(), this._visible = !1, this._listeners = {};
  }
  getId() {
    let t = this._attributes.id;
    return t !== void 0 || (t = this._model._nextUniqueId(), this._setId(t)), t;
  }
  getModel() {
    return this._model;
  }
  getType() {
    return this._attributes.type;
  }
  getParent() {
    return this._parent;
  }
  getChildren() {
    return this._children;
  }
  getRect() {
    return this._rect;
  }
  isVisible() {
    return this._visible;
  }
  getOrientation() {
    return this._parent === void 0 ? this._model.isRootOrientationVertical() ? n.VERT : n.HORZ : n.flip(this._parent.getOrientation());
  }
  // event can be: resize, visibility, maximize (on tabset), close
  setEventListener(t, e) {
    this._listeners[t] = e;
  }
  removeEventListener(t) {
    delete this._listeners[t];
  }
  /** @internal */
  _setId(t) {
    this._attributes.id = t;
  }
  /** @internal */
  _fireEvent(t, e) {
    this._listeners[t] !== void 0 && this._listeners[t](e);
  }
  /** @internal */
  _getAttr(t) {
    let e = this._attributes[t];
    if (e === void 0) {
      const i = this._getAttributeDefinitions().getModelName(t);
      i !== void 0 && (e = this._model._getAttribute(i));
    }
    return e;
  }
  /** @internal */
  _forEachNode(t, e) {
    t(this, e), e++;
    for (const i of this._children)
      i._forEachNode(t, e);
  }
  /** @internal */
  _setVisible(t) {
    t !== this._visible && (this._fireEvent("visibility", { visible: t }), this._visible = t);
  }
  /** @internal */
  _getDrawChildren() {
    return this._children;
  }
  /** @internal */
  _setParent(t) {
    this._parent = t;
  }
  /** @internal */
  _setRect(t) {
    this._rect = t;
  }
  /** @internal */
  _setWeight(t) {
    this._attributes.weight = t;
  }
  /** @internal */
  _setSelected(t) {
    this._attributes.selected = t;
  }
  /** @internal */
  _isFixed() {
    return this._fixed;
  }
  /** @internal */
  _layout(t, e) {
    this._rect = t;
  }
  /** @internal */
  _findDropTargetNode(t, e, i) {
    let r;
    if (this._rect.contains(e, i)) {
      if (this._model.getMaximizedTabset() !== void 0)
        r = this._model.getMaximizedTabset().canDrop(t, e, i);
      else if (r = this.canDrop(t, e, i), r === void 0 && this._children.length !== 0) {
        for (const _ of this._children)
          if (r = _._findDropTargetNode(t, e, i), r !== void 0)
            break;
      }
    }
    return r;
  }
  /** @internal */
  canDrop(t, e, i) {
  }
  /** @internal */
  _canDockInto(t, e) {
    if (e != null) {
      if (e.location === s.CENTER && e.node.isEnableDrop() === !1 || e.location === s.CENTER && t.getType() === "tabset" && t.getName() !== void 0 || e.location !== s.CENTER && e.node.isEnableDivide() === !1)
        return !1;
      if (this._model._getOnAllowDrop())
        return this._model._getOnAllowDrop()(t, e);
    }
    return !0;
  }
  /** @internal */
  _removeChild(t) {
    const e = this._children.indexOf(t);
    return e !== -1 && this._children.splice(e, 1), this._dirty = !0, e;
  }
  /** @internal */
  _addChild(t, e) {
    return e != null ? this._children.splice(e, 0, t) : (this._children.push(t), e = this._children.length - 1), t._parent = this, this._dirty = !0, e;
  }
  /** @internal */
  _removeAll() {
    this._children = [], this._dirty = !0;
  }
  /** @internal */
  _styleWithPosition(t) {
    return t == null && (t = {}), this._rect.styleWithPosition(t);
  }
  /** @internal */
  _getTempSize() {
    return this._tempSize;
  }
  /** @internal */
  _setTempSize(t) {
    this._tempSize = t;
  }
  /** @internal */
  isEnableDivide() {
    return !0;
  }
  /** @internal */
  _toAttributeString() {
    return JSON.stringify(this._attributes, void 0, "	");
  }
}
export {
  u as Node
};
//# sourceMappingURL=Node.js.map
